module.exports = __webpack_public_path__ + "img/wuhantiyu.73b948bf.jpg";